// DailySummarySignatureSection.js
// This component handles the Team Leader Signature section of the Daily Summary tab

import React, { useState } from "react";
import Select from "react-select";
import { SignatureModal } from "../../../../common/SignatureModal";
import styles from "./DailySummarySignatureSection.module.css";

// Confirmation Modal Component
const ConfirmationModal = ({ isOpen, title, message, onCancel, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.confirmationModalOverlay}>
      <div className={styles.confirmationModalContent}>
        <h3 className={styles.confirmationModalHeader}>{title}</h3>
        <p className={styles.confirmationModalMessage}>{message}</p>
        <div className={styles.confirmationModalButtons}>
          <button className={styles.confirmCancel} onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.confirmDelete} onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

// Main DailySummarySignatureSection Component
export const DailySummarySignatureSection = ({
  summaryData,
  allEmployees,
  samplingEventMode = "edit", // Default to edit mode if not provided
  ui,
  actions,
  emitPatch,
}) => {
  const isSignatureModalOpen =
    !!ui?.signatureModal?.isOpen &&
    ui?.signatureModal?.forSummaryId === summaryData.id;
  const isConfirmModalOpen =
    !!ui?.deleteSignatureConfirm?.isOpen &&
    ui?.deleteSignatureConfirm?.forSummaryId === summaryData.id;

  // Get current signature data from summaryData
  const hasEmployee = !!summaryData.teamLeaderSignatureEmployeeId;
  const hasSignature = !!summaryData.teamLeaderSignature;

  // Handle employee selection from dropdown
  const handleEmployeeChange = (selected) => {
    // Update both employee ID and name
    actions.updateSelectedTeamLeader(summaryData.id, selected);
    actions.updateDailySummary(
      summaryData.id,
      {
        teamLeaderSignatureEmployeeId: selected?.value || null,
      },
      emitPatch
    );
  };

  // Handle opening signature modal
  const handleSignatureClick = () => {
    if (samplingEventMode === "view") return;
    actions.openSignatureModal(summaryData.id);
  };

  // Handle saving signature
  const handleSaveSignature = (signatureData) => {
    actions.updateSignatureImage(summaryData.id, signatureData);
    actions.updateDailySummary(
      summaryData.id,
      {
        teamLeaderSignature: signatureData,
      },
      emitPatch
    );
    actions.closeSignatureModal();
  };

  // // Handle delete click - open confirmation dialog
  // const handleDeleteClick = () => {
  //   actions.openDeleteSignatureConfirm(summaryData.id);
  // };

  // // Cancel deletion
  // const handleCancelDelete = () => {
  //   actions.closeDeleteSignatureConfirm();
  // };

  // // Confirm deletion - clear all signature data
  // const handleConfirmDelete = () => {
  //   const updatedSummary = {
  //     ...summaryData,
  //     teamLeaderSignatureEmployeeId: null,
  //     teamLeaderSignatureName: null,
  //     teamLeaderSignature: "",
  //   };

  //   onSaveSummary(updatedSummary);
  //   actions.closeDeleteSignatureConfirm();
  // };

  return (
    <div className={styles.samplerSignaturesSection}>
      <div className={styles.sectionHeader}>
        <h4>Team Leader Signature</h4>
      </div>

      <div className={styles.signatureCardList}>
        <div className={styles.signatureCard}>
          <div className={styles.signatureCardHeader}>
            <Select
              value={
                hasEmployee
                  ? {
                      value: summaryData.teamLeaderSignatureEmployeeId,
                      label: summaryData.teamLeaderSignatureName,
                    }
                  : null
              }
              onChange={handleEmployeeChange}
              options={allEmployees.map((emp) => ({
                value: emp.employee_id,
                label: emp.name,
              }))}
              isDisabled={samplingEventMode === "view"}
              placeholder="Select Team Leader"
              isClearable={true}
              isSearchable={true}
              className={styles.employeeSelect}
            />
          </div>

          <div
            className={styles.signatureDisplay}
            onClick={
              samplingEventMode !== "view" ? handleSignatureClick : undefined
            }
          >
            {hasSignature ? (
              <img
                src={summaryData.teamLeaderSignature}
                alt="Team Leader signature"
                className={styles.signatureImage}
              />
            ) : (
              <div className={styles.emptySignature}>
                <span disabled={samplingEventMode === "view"}>
                  Click to sign
                </span>
              </div>
            )}
          </div>

          <div className={styles.signatureCardActions}>
            <button
              className={styles.signButton}
              onClick={handleSignatureClick}
              disabled={samplingEventMode === "view" || !hasEmployee}
            >
              Sign
            </button>
            {/* <button
              className={styles.deleteButton}
              onClick={handleDeleteClick}
              disabled={
                samplingEventMode === "view" || (!hasEmployee && !hasSignature)
              }
            >
              Delete
            </button> */}
          </div>

          {/* Signature Modal */}
          <SignatureModal
            isOpen={isSignatureModalOpen}
            onClose={() => actions.closeSignatureModal()}
            signee={summaryData.id} // Use summary ID as signee identifier
            existingSignature={summaryData.teamLeaderSignature}
            onSave={handleSaveSignature}
            onClear={() => {}}
          />
        </div>
      </div>

      {/* Confirmation Modal for deletion */}
      {/* <ConfirmationModal
        isOpen={isConfirmModalOpen}
        title="Delete Team Leader Signature"
        message="Are you sure you want to delete this signature? This action cannot be undone."
        onCancel={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      /> */}
    </div>
  );
};
